export default "__VITE_ASSET__aQ90KRFt__"